<template>
	<div class="investmentClues">
		<leftnav class="fl" mkcode="C"
			itemcode="C-ZDQYQYPH"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title"
							v-if="curWebsite.type != 5 && curWebsite.type != 6">{{ curWebsite.keyword }}{{ curWebsite.type
								== 2 ? '' :'线索'}}</span>
						<span class="fl right_title" v-if="curWebsite.type == 6">产业排行榜</span>
						<span class="fl right_title" v-if="curWebsite.type == 5">区域企业推荐</span>
						<cluetips v-if="curWebsite.type != 5"></cluetips>
						<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<ClueNav tabCode="zdqyzs" v-if="curWebsite.type != 5"></ClueNav>
							<dl class="opport-screen bdbe">
								<dt class="fl">企业类型</dt>
								<dd class="fl">
									<span :class="companytype == 1 ? 'a-screen current' : 'a-screen'"
										@click="isShowFreeUserTips = true">上市公司</span>
									<span :class="companytype == 2 ? 'a-screen current' : 'a-screen'"
										@click="isShowFreeUserTips = true">龙头企业</span>
									<span :class="companytype == 3 ? 'a-screen current' : 'a-screen'"
										@click="isShowFreeUserTips = true">创新企业</span>
									<span :class="companytype == 4 ? 'a-screen current' : 'a-screen'"
										@click="isShowFreeUserTips = true">优质企业</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">重点区域</dt>
								<dd class="fl">
									<!-- 	<span :class="provinceid == 0?'current a-screen':'a-screen'"
							@click="provincechoose(0,'all');userdata.provinceText='全国地区';getclue()">全国地区</span> -->
									<span v-for="(item, index) in provincedata" :key="'province' + index"
										@click="provincechoose(item.id, index)"
										:class="item.id == provinceid ? 'a-screen current' : 'a-screen'">{{ item.name }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">重点城市</dt>
								<dd class="fl">
									<span :class="cityid == 0 ? 'current a-screen' : 'a-screen'"
										@click="choosecity(0, 'all')">全部</span>
									<span v-for="(item, index) in citydata" :key="'city' + index"
										@click="choosecity(item.areaId, index); cityid = item.areaId;"
										:data="item.areaId"
										:class="item.areaId == cityid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
								</dd>
							</dl>
						</div>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 表格内容开始 -->
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<!-- 多维度分数筛选 -->
					<ul class="dimensionScreen oh w95mg" v-show="enterpristlist.length > 0">
						<li :class="orderField == list.type ? 'fl current ' : 'fl '" v-for="(list, index) in dimensionList"
							:key="'order' + index" @click="tablesort(list.type);"
							v-show="list.name != '融资时间' || searchtype == 2">
							<span
								:class="{ 'sortname ': true, 'current': orderField == list.type, 'fz15': list.name.length > 5 }">{{ list.name }}</span>
							<span :class="orderType == 1 ? 'timesorticon up' : 'timesorticon down'"></span>
						</li>
					</ul>
					<!-- 重点区域招商 -->
					<div class="enterprise_list_box">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="enterpristlist.length > 0">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>投资力度</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list, i) in enterpristlist" :key="'enterpirse' + i">
								<td>{{ 20 * (page - 1) + i + 1 }}</td>
								<td class="title" @click="routerlinkid('/enterprises', list.stockCode, 2, '', 'all')">
									{{ list.title }}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="(item, i) in list.notionlist" :key="'nontion' + i"
										@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'clue1')">{{ item.name }}</span>
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="(item, i) in list.taglist" :key="'tag' + i"
										@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name, 'clue1')">{{ item.name }}</span>
								</td>
								<td>{{ list.area }}</td>
								<td>{{ list.zs100000 }}</td>
								<td>{{ list.zs200000 }}</td>
								<td class="collectfont1"><span @click="listToggleCollect(list)">{{ list.collectId ==
									0 ?'加入':'移除'}}<br />目标企业</span></td>
							</tr>
						</table>
					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { dataInJs } from "../../utils/city.js";
import { areasdata } from "../../utils/areas.js";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'investmentClues1',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "重点区域企业排行",
			notionlist: [],//用户初始概念数据   
			usernotionlistsave: [],//用户选择的概念列表存储
			usernotionlist: [],//用户选择的概念列表 
			userdata: {}, curWebsite: this.$api.getWebsiteType(),
			searchtype: 2, //线索类型 2以商招商 1本省投资概率 3关键融资 4优质企业 
			pro: 11,
			companytype: 1, //1上市 2非上市公司
			node: 1,
			pro4: 0,
			liancity: 0, //产业链线索城市
			city4: 1,
			industryid: 0,
			frequency: 1, //融资频次
			enterpristlist: [],
			recommendLevel: 3,
			strcolors: ['#3A66BE', '#3A66BE', '#3A66BE'],
			provincedata: [],
			countydata: [],
			citydata: [],
			provinceid: 1,
			cityid: 0,
			countyid: 0,
			industryoptions1: [],
			lianctiy: [],
			cstype: 1, //1供应商 2客户
			supplierlist: [],//供应商列表
			customerlist: [],//客户列表
			ipolist: [],//上市公司列表
			enterpristlist: [],
			page: 1,  //显示的是哪一页
			haspage: true,//是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数 
			totalPage: 1,
			maxPage: 10,  //最大页数
			sort: 5, //上市公司招商线索 排序 1营业收入 2营业增速 3净利润 4净利增速 5投资意愿
			notionguide: [{ name: '先进制造业', children: [] }, { name: '传统制造业', children: [] }, { name: '未来产业', children: [] },],
			areadata: areasdata(), //城市划区数据
			dimensionList: [
				{ name: '综合', type: 0 }, { name: '融资时间', type: 1 }, { name: '企业实力', type: 2 }, { name: '投资力度', type: 3 },
				{ name: '本省关联度', type: 4 }, { name: '拿地数量', type: 5 }, { name: '拿地面积', type: 6 }, { name: '拿地金额', type: 7 }, { name: '投资项目数量', type: 8 }, { name: '投资项目金额', type: 9 }],
			orderField: 0, //排序字段 0 分数 1 时间
			orderType: 0, //排序方式 0 降序 1 升序   
			isShowFreeUserTips: false,
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuseriformation();
		//获取省份城市列表
		// this.$axios.get(this.$api.cyl.area.get(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
		// 	// console.log('省份城市列表'，res.data)
		// 	if(res.data.success){   
		// 	 _this.provincedata=res.data.list; 
		// 		_this.getindustry();
		// 	}else{ 
		// 		
		// 	} 
		// }).catch(function (error) { 
		// 	// 请求失败处理 console.log(error);
		// }); 
		_this.provincedata = this.areadata;
		console.log('this.areadata', this.areadata)
		_this.provincechoose(this.areadata[0].id, 0);
		console.log(_this.provincedata);
		_this.getindustry();
		this.$axios.get(this.$api.cyl.notion.list() + '?level=4',{headers:{AuthToken:this.userdata.token}}).then(function (res) {
			if (res.data.success) {
				var ddds = [];
				// console.log(res.data)
				_this.notionlist = res.data.list == null ? [] : res.data.list;
			} else {

			}
		});
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		this.notionclickfun([{ name: '', id: '' }]);
		this.getclue();
		document.title = this.title;
		// this.getareaclue(this.pro);
	},
	methods: {
		//时间/分数升降序
		tablesort(field) {
			this.isShowFreeUserTips = true;
			return;
			if (field == this.orderField) {
				this.orderType = Math.abs(this.orderType - 1);
			} else {
				this.orderField = field;
			}
			this.getclue();
		},
		//导航栏筛选
		notionclickfun(arry) {
			if(arry[0].id != ''){
				this.isShowFreeUserTips = true;
				return;
			}
			this.usernotionlist = arry;
			this.usernotionlistsave = arry;
			// console.log('arr',arry);
			this.getclue();
		},
		chartmapclick: function (data) {
			var type = "";
			if (data.data != undefined && data.data.length > 0) {
				type = 1;
			};
			this.choosecityid(data.id, type);
			// this.notionslide3=false; 
		},
		choosecityide(art) {
			// console.log(art);
			this.choosecityid(art[0], art[1]);
		},
		//省份城市选择
		provincechoose(id, i) {
			if(i != 0 ){
				this.isShowFreeUserTips = true;
				return;
			}
			this.provinceid = id; this.cityid = 0; this.countyid = 0;
			this.countydata = [];
			if (i != "all" && this.provincedata[i].children != null) {
				this.citydata = this.provincedata[i].children;
			} else {
				this.citydata = [];
			}
			this.page = 1;
			// this.ajaxsearchcompany();
		},
		choosecity(id, i) {
			//	console.log('choosecity',id);
			this.cityid = id; this.countyid = 0;
			if (i != "all" && this.citydata[i].children != null) {
				this.countydata = this.citydata[i].children;
			} else {
				this.countydata = [];
			}
			this.page = 1;
			// this.ajaxsearchcompany(); 
		},
		choosecounty(id) {
			//	console.log('choosecity',id);
			this.countyid = id;
			this.page = 1;
			// this.ajaxsearchcompany();
		},
		//获取行业分类
		getindustry() {

			var _this = this;
			this.$axios.get(this.$api.free.parameter.stockIndustry()).then(function (res) {
				console.log("行业分类", res);
				if (res.data.success) {
					_this.industryoptions1 = res.data.list;

				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		notionlistnumber(namelist, codelist) {
			// console.log(namelist,codelist); 
			for (var i = 0; i < namelist.length; i++) {
				let arry2 = namelist[i].children;
				for (var d = 0; d < namelist[i].children.length; d++) {
					for (var s = 0; s < codelist.length; s++) {
						if (namelist[i].children[d].value == codelist[s].code) {
							namelist[i].children[d].count = codelist[s].count;
						}
					}
					//二级
					// console.log('q',namelist[i].children[d].label);
					if (namelist[i].children[d].children != null) {
						for (var f = 0; f < namelist[i].children[d].children.length; f++) {
							for (var s = 0; s < codelist.length; s++) {
								if (namelist[i].children[d].children[f].value == codelist[s].code) {
									namelist[i].children[d].children[f].count = codelist[s].count;
								}
							}
							// console.log('f',namelist[i].children[d].children[f].label);
							if (namelist[i].children[d].children[f].children != null) {
								for (var g = 0; g < namelist[i].children[d].children[f].children.length; g++) {
									for (var s = 0; s < codelist.length; s++) {
										if (namelist[i].children[d].children[f].children[g].value == codelist[s].code) {
											namelist[i].children[d].children[f].children[g].count = codelist[s].count;
										}
									}
									// console.log('g',namelist[i].children[d].children[f].children[g].label); 
									//
								}
							}
							//
						}
					}
					//
				}
			};
			this.notionlist = namelist;
		},
		//获取产业链/区域/融资企业招商线索
		getclue(pages) {
			var _this = this, ajaxurl = '';
			this.page = pages ? pages : 1;
			if (this.usernotionlistsave[0].id == '') {
				var notionja = '';
			} else {
				var notionja = _this.jsondouhao('notionList', this.usernotionlistsave);
			}
			// ajaxurl=this.$api.cyl.investclue.area()+'?ipo='+this.companytype+'&province='+notionja+this.pro+'&page='+ajpage;
			//"&orderField=" + this.orderField + "&orderType=" + this.orderType+
			ajaxurl = this.$api.free.investclue.keyarea();
			_this.bus.$emit('loading', true);
			this.$axios.get(ajaxurl).then(function (res) {
				console.log(_this.searchtype, "招商", res, ajaxurl);
				if (res.data.success) {
					_this.enterpristlist = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion, _this.enterpristlist[i].notionCode);
						_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this.enterpristlist[i].tagCode);

					}

					// _this.notionlistnumber(_this.notionlist,res.data.extend.notionList);	//悬浮导航概念筛选
					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			if (page > 1) {
				this.isShowFreeUserTips = true;
				return;
			}
			this.getclue(page);
		},
		jsondouhao(name, data) {
			if (data.length > 0) {
				var notionja = "";
				if (data.length != 0) {
					var douhao = '%2C';
					for (var i = 0; i < data.length; i++) {
						if (i == data.length - 1) {
							douhao = '';
						}
						notionja += data[i].id + douhao;
					}
					notionja = '&' + name + '=' + notionja;
					return notionja;
				}
			} else {
				return "";
			}
		},
	},
}
</script>

<style>
/* 提示框箭头 */
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
	border-top-color: #E0E8F9;
}

.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
	border-top-color: #E0E8F9;
}

/* 提示框背景色 */
.atooltip {
	background: #E0E8F9 !important;
}
</style>
<style>
.a-red {
	color: #c00;
}
</style>
